export default {
    imageProductsOverlayData: {
        headline: "Shop products",
        items: "",
        backgroundColor: "white",
        noBuySection: true
    }
}
